import * as React from 'react';
import { Redirect } from 'react-router';
import * as _ from 'underscore';

import { Favorites } from '../../../content/resources/Favorites';
import { Projects } from '../../../projects/resources/Projects';
import { Filter } from '../../../ts/helpers/Filter';
import { IProjectInfo } from '../../../ts/models/IProjectInfo';
import { RouterError } from '../RouterHelpers/RouterError';
import { SpacesSiteUrls } from '../SpacesSiteUrls';

export interface RedirectToFavoritedProjectProviderProps {
  readonly projectId: string;
  readonly urls: SpacesSiteUrls;
}

export interface RedirectToFavoritedProjectProviderState {
  readonly projectExists: boolean;
  readonly hasError: boolean;
}

const InitialState: RedirectToFavoritedProjectProviderState = {
  projectExists: false,
  hasError: false
};

export class RedirectToFavoritedProjectProvider extends React.PureComponent<RedirectToFavoritedProjectProviderProps, RedirectToFavoritedProjectProviderState> {
  private unmounted: boolean = false;

  public constructor(props: RedirectToFavoritedProjectProviderProps) {
    super(props);
    this.state = InitialState;
  }

  public render(): JSX.Element {
    if (this.state.hasError) {
      return <RouterError errorType={'project-removed-favorite'} urls={this.props.urls} />;
    } else if (this.state.projectExists) {
      return <Redirect to={this.props.urls.projectPath(this.props.projectId)} />;
    }

    return null;
  }

  public async componentDidMount() {
    if (_.isUndefined(this.props.projectId)) {
      this.setToErrorStateAndRemoveFromFavorites();
      return;
    }

    try {
      const project: IProjectInfo = await Projects.all()
        .withFilters([Filter.fieldEq('id', this.props.projectId)])
        .getFirst();

      if (project) {
        this.updateState({ projectExists: true });
      } else {
        this.setToErrorStateAndRemoveFromFavorites();
      }

    } catch (e) {
      this.setToErrorStateAndRemoveFromFavorites();
    }
  }

  private setToErrorStateAndRemoveFromFavorites() {
    Favorites.remove(this.props.projectId, 'project');
    this.updateState({ hasError: true });
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  private updateState<K extends keyof RedirectToFavoritedProjectProviderState>(newState: Pick<RedirectToFavoritedProjectProviderState, K>): void {
    if (!this.unmounted) {
      this.setState(newState);
    }
  }
}
